import { IAsset, IAssetResponse, InfoBox } from '@desp-aas/desp-ui-fwk';
import './RejectionReason.css';
import React, { useMemo } from 'react';

type IRejectionReasonProps = {
    assetResponse?: IAssetResponse;
    editMode?: boolean;
}
export const RejectionReason = (props: IRejectionReasonProps) => {

    const rejectionReason = useMemo(() => {
        // return `The asset has been reject for these reasons:\n* bad\n* very bad`;
        // return props.asset.rejection_reason;
        return props.assetResponse?.reasons?.reason;
    }, [ props.assetResponse ]);

    if(!rejectionReason || !props.editMode) {
        return null;
    }

    return (
        <div className="section">
            <InfoBox id="rejection-reason" type="error" title="Rejection reason" className="asset-page-info-box">
                { rejectionReason }
            </InfoBox>
        </div>
    );
};